import { render, staticRenderFns } from "./PanelMensajes.vue?vue&type=template&id=a3715f70&scoped=true&functional=true&"
var script = {}
import style0 from "./PanelMensajes.vue?vue&type=style&index=0&id=a3715f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a3715f70",
  null
  
)

export default component.exports